export const TAB_NAMES = {
  ELEMENTS: 'elements',
  NETWORK: 'network',
  GRAPHICS: 'graphics',
} as const;
